// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vEas","comment":"styles_comment__3cGKL"};